// english stays on the domain the player is already on, every other language
// goes to its own domain. the worker in front of ssr redirects language paths,
// isredirect=false tells it to skip that redirect so we can stay put

export const NO_REDIRECT_PARAM = 'isredirect=false';

// "Lemon- en" -> "en", "pl" -> "pl", "de-AT" -> "de-AT"
export function extractLanguageCode(rawName: string | null | undefined): string {
  if (!rawName) {
    return '';
  }
  const parts = rawName.split('-');
  return parts[0] === 'Lemon' && parts.length > 1 ? parts.slice(1).join().trim() : parts.join('-').trim();
}

export function languageSwitchUrl(rawName: string | null | undefined): string | null {
  const langCode = extractLanguageCode(rawName);
  if (langCode && langCode.toLowerCase() === 'en') {
    return `/${langCode}/?${NO_REDIRECT_PARAM}`;
  }
  return null;
}
